import { useQuery } from "@tanstack/react-query";

import { api } from "@/APIRequests";

import { policyMetadataKeys } from "../keyFactory";

export function usePolicyMetadataQuery() {
  return useQuery({
    cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
    queryFn: api.publicTyped.get_policy_metadata,
    queryKey: policyMetadataKeys.base,
    staleTime: 10 * 60 * 1000, // 10 minutes - policies don't change often
  });
}
